var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverCrossIconLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.49 28.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.31,8.96c-.31-1.58-.34-3.2-.08-4.79-.05.12-1.38,2.87-1.15,5.14.25,2.45,2.16,4.74,4.1,6.87,2.1,2.3,4.26,4.68,4.24,7.08.03.45-.03.9-.19,1.32-.15.42-.4.81-.71,1.13-1.21,1.15-3.4,1.15-4.75,1.11v-8.95H1.85v-7.07h5.38v-1.85H0v10.77h8.92v8.92h.92c.13,0,.3,0,.49.01h.03c.3.01.68.03,1.09.03,2.45,0,4.2-.53,5.35-1.63.49-.5.88-1.09,1.13-1.74s.37-1.35.34-2.05c.03-3.12-2.39-5.77-4.72-8.34-1.93-2.13-3.79-4.32-4.23-5.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.58.04h-.92c-.13,0-.3,0-.49,0h-.03c-.3,0-.68-.03-1.09-.03-2.45,0-4.2.53-5.35,1.63-.49.5-.88,1.09-1.13,1.74-.25.65-.37,1.35-.34,2.05-.03,3.12,2.39,5.77,4.72,8.34,1.93,2.13,3.79,4.32,4.23,5.96.31,1.58.34,3.2.08,4.79.05-.12,1.38-2.87,1.15-5.14-.25-2.45-2.16-4.74-4.1-6.87-2.1-2.3-4.26-4.68-4.24-7.08-.03-.45.03-.9.19-1.33.15-.42.4-.81.71-1.13,1.21-1.15,3.4-1.15,4.75-1.11v8.95h8.92v7.07h-5.38v1.85h7.23v-10.77h-8.92V.04h.01Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverCrossIconLogo);
export default __webpack_public_path__ + "static/media/SilverCross_Icon_Logo.604ccc5e9fb0d6e9fe543e22d7dae922.svg";
export { ForwardRef as ReactComponent };